import { chemicalUsageToLabel } from 'aos-services/src/services/tasks/types/task/DeIcingChemicalUsage'
import { translateSurfaceType } from 'aos-services/src/services/tasks/types/task/DeIcingSurfaceType'
import { DeIcingTask } from 'aos-services/src/services/tasks/types/task/DeIcingTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { Box } from 'aos-ui/src/components/base/Box'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'
import React from 'react'

export const deicingTaskPropertyList =
    (translate: TFunction) =>
    (t: DeIcingTask | TaskTemplate<DeIcingTask>): PropsListEntry[] => [
        [
            'tasks.task-preview.surface-type',
            t.surfaceType ? translateSurfaceType(translate)(t.surfaceType) : '-',
        ],
        ['tasks.task-preview.temperature', t.temperature],
        ['tasks.task-preview.area', t.area?.label],
        ['tasks.task-preview.car', t.car?.label],
        [
            'tasks.task-preview.chemicals',

            t.chemicalsUsage?.length ? (
                <Box>
                    {t.chemicalsUsage.map((ch, index) => (
                        <Box key={index}>{chemicalUsageToLabel(ch)}</Box>
                    ))}
                </Box>
            ) : null,
        ],
    ]
